import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

import { MatchingPasswordValidatorDirective } from './matching-password.directive';

@Component({
  selector: 'auth-new-password',
  imports: [FormsModule, MatInputModule, MatchingPasswordValidatorDirective],
  templateUrl: './new-password.component.html',
  styleUrl: './new-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class NewPasswordComponent {
  public readonly formData = input<{ newPassword: string }>({ newPassword: '' });
  protected passwordConfirmation = '';
}
